import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import useColors from 'hooks/useColors';
import { formatAmount } from 'utils/formatting';
import Text from './Text';
import { rem } from './values';
import { Spacer } from './Spacer';
import { ProgressBar } from './ProgressBar';
const BuySellHold = ({ variable, buyPercent = 0, holdPercent = 0, sellPercent = 0, }) => {
    const colors = useColors();
    return (<View style={styles.barViewContainer}>
      <View>
        <View style={styles.barInfo}>
          <Text TextThin-14 Secondary>
            Buy
          </Text>
        </View>
        <Spacer h={6}/>
        <View style={styles.barInfo}>
          <Text TextThin-14 Secondary>
            Hold
          </Text>
        </View>
        <Spacer h={6}/>
        <View style={styles.barInfo}>
          <Text TextThin-14 Secondary>
            Sell
          </Text>
        </View>
      </View>
      <Spacer w={16}/>
      <View style={styles.barContainer}>
        <View style={styles.progressBarContainer}>
          <ProgressBar position={buyPercent} colors={[colors.status.positive, colors.status.positive]}/>
        </View>
        <Spacer h={6}/>
        <View style={styles.progressBarContainer}>
          <ProgressBar position={holdPercent} colors={[colors.text.tertiary, colors.text.tertiary]}/>
        </View>
        <Spacer h={6}/>
        <View style={styles.progressBarContainer}>
          <ProgressBar position={sellPercent} colors={[
            colors.elements.statusNegative,
            colors.elements.statusNegative,
        ]}/>
        </View>
      </View>
      <Spacer w={variable ? 8 : 16}/>
      <View style={!!variable && styles.variableContainer}>
        <View style={styles.barInfoRight}>
          <Text TextThin-14 Secondary>
            {formatAmount(buyPercent, undefined, 2)}%
          </Text>
        </View>
        <Spacer h={6}/>
        <View style={styles.barInfoRight}>
          <Text TextThin-14 Secondary>
            {formatAmount(holdPercent, undefined, 2)}%
          </Text>
        </View>
        <Spacer h={6}/>
        <View style={styles.barInfoRight}>
          <Text TextThin-14 Secondary>
            {formatAmount(sellPercent, undefined, 2)}%
          </Text>
        </View>
      </View>
    </View>);
};
export default memo(BuySellHold);
const styles = StyleSheet.create({
    barViewContainer: {
        flex: 1,
        flexDirection: 'row',
    },
    barContainer: {
        flex: 1,
    },
    barInfo: {
        paddingVertical: rem(4),
    },
    barInfoRight: {
        alignItems: 'flex-end',
        paddingVertical: rem(4),
    },
    progressBarContainer: {
        flex: 1,
        justifyContent: 'center',
    },
    variableContainer: {
        width: rem(62),
    },
});
